import { memo } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { resetSearch } from '~/Actions/ActionCategory';
import NavMap, { NavItemType } from '~/Components/Nav/NavMap';
import { playButtonClickSound } from '~/helpers/audioApi';
import { DWH_EVENTS, Places } from '~/helpers/consts';
import dwhExport from '~/helpers/dwhExport';

import styles from './Nav.scss';

const Nav = () => {
    const dispatch = useDispatch();
    const classes = classNames(styles.nav, styles.blurable);
    const onClick = (item: NavItemType) => {
        dwhExport.send(DWH_EVENTS.PAGE_OPEN, { name: item.name, from: Places.MENU });
        dispatch(resetSearch());
        playButtonClickSound();
    };

    return (
        <nav className={classes}>
            {NavMap.map((navItem, index) => {
                return (
                    <NavLink
                        key={`nav_${navItem.name}_${index}`}
                        to={navItem.link}
                        className={({ isActive }) => classNames(styles.link, { [styles.linkCurrent]: isActive })}
                        onClick={() => {
                            onClick(navItem);
                        }}
                    >
                        {navItem.title}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default memo(Nav);
